// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Terms_componentWrapper__McyWe","content":"Terms_content__SzfOz"};